import React from 'react';
import { Button, Flex } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import { useDeleteBannerMutation } from '../service/banners';
import { ConfirmationDialog } from '../../../../../shared/ui/ConfirmationDialog';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';

export const BannerControls = ({ bannerId }: { bannerId: number }) => {
    const navigate = useNavigate();
    const current = useAppSelector(selectShopCurrent);

    const [deleteBanner] = useDeleteBannerMutation();
    const handleDelete = async () => {
        const payload = {
            shopId: current.id,
            bannerId: +bannerId,
        };

        await deleteBanner(payload);
    };

    const handleEdit = () => {
        navigate(`edit/${bannerId}`);
    };

    return (
        <Flex
            align={'flex-start'}
            vertical={false}
            gap={8}
            style={{ marginLeft: 'auto' }}
        >
            <ConfirmationDialog
                activator={
                    <Button size={'small'}>
                        <DeleteOutlined />
                    </Button>
                }
                onConfirm={handleDelete}
                title='Удалить баннер?'
                description={
                    'Внимание! Восстановить баннер после удаления будет невозможно.'
                }
                withCheckbox
            />

            <Button size={'small'}>
                <EditOutlined onClick={handleEdit} />
            </Button>
        </Flex>
    );
};
